'use client'

import { useReducer } from 'react'

const Rerender = () => {
  const rerender = useReducer(() => ({}), {})[1]

  return (
    <div className="gap-x-2">
      <button
        type="button"
        className="focus-custom flex w-20 h-7 rounded-md justify-center items-center border-custom"
        onClick={() => {
          console.log('rerender')
          rerender()
        }}
      >
        <span className="break-keep">Rerender</span>
      </button>
    </div>
  )
}

export default Rerender
